import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';
import type { NewPlayer } from '@/types';

export const useNewPlayersStore = defineStore('newPlayers', () => {
    const newPlayers = ref<NewPlayer[]>([]);
    function toAddNewPlayer(player: NewPlayer): void {
        if (!newPlayers.value.length) return;
        if (newPlayers.value.find((item) => item.id === player.id)) {
            const idx = newPlayers.value.findIndex((item) => item.id === player.id);
            newPlayers.value[idx] = player;
        } else {
            newPlayers.value.unshift(player);
        }
    }
    const awaitGetNewPlayers = async () => {
        try {
            const response = await axios.get<NewPlayer[]>('/main-api/users/get_new_players');
            if (response.status === 200) {
                newPlayers.value = response.data;
            }
        } catch (error) {
            console.error(error);
        }
    };
    return { newPlayers, awaitGetNewPlayers, toAddNewPlayer };
});
